import React, { useEffect, useState } from 'react';
import '../Styles/SignUp.scss';
import Logo from '../Images/ht_logo_final.png';
import useGoogleAnalytics from '../CustomHooks/useGoogleAnalytics';

export default function SignUp__Success(props) {
    const [guiLanguage, setGuiLanguage] = useState('en');
    const setGAPath = useGoogleAnalytics();

    useEffect(
        () => {
            //setGAPath('/SignUp');
        }, []
    )
    
    useEffect(
        () => {
            if (window.location.href.indexOf('lang=tr') > 0) {
                setGuiLanguage('tr');
            }
        }, []
    )

    return (


        <div className="sign-up-success">
            <div>
                <div>
                    <img src={Logo} className="sign-up__logo"></img>
                </div>
                <span class="material-icons" style={{ color: 'green', fontWeight: '900', fontSize: '64px', marginTop: '50px' }}>
                    done
                    </span>
            </div>
            {
                guiLanguage == 'tr' ?
                    <React.Fragment>
                        <div>
                            Hesabınıza bir e-posta gönderdik. E-posta içindeki bağlantıya tıklayarak hesabınızı etkinleştirin.
                    </div>
                        <div style={{marginTop: '20px',fontSize: '1rem',}}>
                            HappyTable'dan bir e-posta almadıysanız lütfen öncelikle "Spam" klasörünüzü kontrol edin. Eğer "Spam" klasörünüzde de tarafımızdan gelen bir e-posta bulunmuyorsa lütfen destek@happytable.app adresinden bizimle iletişime geçin.
                    </div>
                    </React.Fragment>
                    :
                    <span>
                        We have sent a mail to your email address with a link. Please click the link in the email to activate your account.
                    </span>

            }

        </div>

    )
}